import React from "react";

interface CheckboxProps {
  label: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked = false,
  onChange,
}) => {
  return (
    <label className="flex space-x-2 cursor-pointer">
      <input
        type="checkbox"
        className="hidden"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <div
        className={`w-5 h-5 flex items-center justify-center border rounded mt-[0.3em] ${
          checked
            ? "bg-perle-red border-perle-red"
            : "border-perle-red bg-white"
        }`}
      >
        <div
          className={`w-5 h-5 flex items-center justify-center border rounded ${
            checked
              ? "bg-perle-red border-perle-red"
              : "border-perle-red bg-white"
          }`}
        ></div>
      </div>
      {/* Label */}
      <span className="text-left">{label}</span>
    </label>
  );
};
